import React from 'react';

import './AppFooter.scss';

export interface AppFooterProps {
  /** Copyright + product line. */
  children?: React.ReactNode;
  /** Version, build hash, environment chip. */
  trailing?: React.ReactNode;
  className?: string;
}

/** Slim mono caption band. NOT from Claude Design. */
export const AppFooter: React.FC<AppFooterProps> = ({
  children,
  trailing,
  className,
}) => (
  <div className={`wb-footer${className ? ' ' + className : ''}`}>
    <span className="wb-footer__primary">{children}</span>
    {trailing && <span className="wb-footer__trailing">{trailing}</span>}
  </div>
);

export default AppFooter;
